import styled, { css } from "styled-components";
import { propStyling } from "../../../shared/propStyling";
import { tombac } from "../../../shared/tombac";
export const Container = styled.button.withConfig({
  displayName: "Container"
})(["all:initial;", " ", ""], _ref => {
  var _hover, _disabled;
  let {
    theme: {
      components: {
        button: {
          current
        }
      }
    }
  } = _ref;
  return css(["align-items:center;background-color:", ";border-radius:9999rem;box-sizing:border-box;display:inline-flex;height:", ";isolation:isolate;justify-content:center;min-width:", ";overflow:hidden;padding:", ";position:relative;text-decoration:none;transition:0.1s ease-out;transition-property:background-color,box-shadow;&:focus-visible{box-shadow:", ";}&:not(:disabled){cursor:pointer;}&:not(:disabled):hover,&:not(:disabled):active{background-color:", ";}&:disabled:not([data-busy]){background-color:", ";}"], tombac.parse(current.backgroundColor), tombac.parse(current.height), tombac.parse(current.height), _ref2 => {
    let {
      $withAddon
    } = _ref2;
    return tombac.parse(`0 ${$withAddon ? current.withAddon.padding : current.padding}`);
  }, tombac.parse(`0 0 0 3u ${current.focusRing}`), tombac.parse((_hover = current.hover) === null || _hover === void 0 ? void 0 : _hover.backgroundColor), tombac.parse((_disabled = current.disabled) === null || _disabled === void 0 ? void 0 : _disabled.backgroundColor));
}, propStyling);
//# sourceMappingURL=Container.js.map